import { Component, OnInit } from '@angular/core';

import { PageHeadingService } from '../../services/page-heading.service';
import { FileService } from '../file.service';
import { ProfileService } from '../../profile/profile.service';
@Component({
  selector: 'app-list-folders',
  templateUrl: './list-folders.component.html',
  styleUrls: ['./list-folders.component.css']
})
export class ListFoldersComponent implements OnInit {

  folders;
  constructor(
    private fileService: FileService,
    private profileService: ProfileService,
    private pageHeadingService: PageHeadingService
  ) { }

  ngOnInit() {
    this.pageHeadingService.setPageHeading("List All Folders");

    this.fileService.getAllDirs()
      .subscribe((res) => {
        this.folders = res;
        //console.log(res);
      });

  }

}
